// extracted by mini-css-extract-plugin
export default {"wrapper":"promotionBanners_wrapper__+coGz","wrapperTop":"promotionBanners_wrapperTop__ubtpj"};